/* Native Shopify forms/events own commerce; this file never emits purchase events. */
(() => {
  const panel = document.getElementById('MC-Privacy');
  if (!panel) return;
  let api;
  let previousFocus;
  const status = panel.querySelector('[role="status"]');
  const analytics = panel.querySelector('[data-consent-analytics]');
  const marketing = panel.querySelector('[data-consent-marketing]');
  const show = (focus = false) => {
    panel.hidden = false;
    if (api) {
      const consent = api.currentVisitorConsent();
      analytics.checked = consent.analytics === 'yes';
      marketing.checked = consent.marketing === 'yes';
    }
    if (focus) panel.querySelector('summary').focus();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-consent-open]')) { previousFocus = event.target; show(true); }
  });
  const save = (allowAnalytics,allowMarketing) => {
    if (!api) { status.textContent = 'Preferences are temporarily unavailable. Please try again shortly.'; return; }
    status.textContent = 'Saving preferences…';
    api.setTrackingConsent({analytics:allowAnalytics,marketing:allowMarketing,preferences:false}, result => {
      if (result?.error) { status.textContent = 'We could not save your preferences. Please try again.'; return; }
      status.textContent = '';
      panel.hidden = true;
      previousFocus?.focus();
    });
  };
  panel.querySelector('[data-consent-accept]').addEventListener('click',()=>save(true,true));
  panel.querySelector('[data-consent-reject]').addEventListener('click',()=>save(false,false));
  panel.querySelector('[data-consent-save]').addEventListener('click',()=>save(analytics.checked,marketing.checked));
  function load() {
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
      if (error || !window.Shopify.customerPrivacy) return;
      api=window.Shopify.customerPrivacy;
      if (api.shouldShowBanner()) show();
    });
  }
  load();
})();
